import * as actionTypes from './actionTypes';

const initialState = {
	licenseInfo: null,
	licenses: [],
	metadata: null,
	pricingTiers: [],
	loading: false,
	error: null
};

const licenseReducer = (state = initialState, action) => {
			switch (action.type) {
		// New licenses list actions
		case actionTypes.LOAD_LICENSES:
			return {
				...state,
				loading: true,
				error: null
			};
			
		case actionTypes.LOAD_LICENSES_SUCCESS:
			return {
				...state,
				licenses: action.payload.licenses,
				metadata: action.payload.metadata,
				loading: false,
				error: null
			};
			
		case actionTypes.LOAD_LICENSES_FAILURE:
			return {
				...state,
				loading: false,
				error: action.payload
			};
			
		// Create license actions
		case actionTypes.CREATE_LICENSE:
			return {
				...state,
				loading: true,
				error: null
			};
			
		case actionTypes.CREATE_LICENSE_SUCCESS:
			return {
				...state,
				loading: false,
				error: null
			};
			
		case actionTypes.CREATE_LICENSE_FAILURE:
			return {
				...state,
				loading: false,
				error: action.payload
			};
			
		// Delete license actions
		case actionTypes.DELETE_LICENSE:
			return {
				...state,
				loading: true,
				error: null
			};
			
		case actionTypes.DELETE_LICENSE_SUCCESS:
			return {
				...state,
				licenses: state.licenses.filter(license => license.id !== action.payload),
				loading: false,
				error: null
			};
			
		case actionTypes.DELETE_LICENSE_FAILURE:
			return {
				...state,
				loading: false,
				error: action.payload
			};
			
		// Load pricing tiers actions
		case actionTypes.LOAD_PRICING_TIERS:
			return {
				...state,
				loading: true,
				error: null
			};
			
		case actionTypes.LOAD_PRICING_TIERS_SUCCESS:
			return {
				...state,
				pricingTiers: action.payload,
				loading: false,
				error: null
			};
			
		case actionTypes.LOAD_PRICING_TIERS_FAILURE:
			return {
				...state,
				loading: false,
				error: action.payload
			};
			
		// Existing license info actions
		case actionTypes.LICENSE_LOADING:
			return {
				...state,
				loading: true,
				error: null
			};
			
		case actionTypes.LICENSE_LOADED:
			return {
				...state,
				licenseInfo: action.data,
				loading: false,
				error: null
			};
			
		case actionTypes.LICENSE_ERROR:
			return {
				...state,
				loading: false,
				error: action.error
			};
			
		default:
			return state;
	}
};

export default licenseReducer; 